import { mutateAdmin, queryAdmin } from '../graphql-client';

export const CREATE_API_KEY_MUTATION = /* GraphQL */ `
  mutation ($role: String, $name: String) {
    apiKey: createApiKey(role: $role, name: $name) {
      name
      role
      apiKey
      id
    }
  }
`;

export const DELETE_API_KEY_MUTATION = /* GraphQL */ `
  mutation ($id: ID) {
    deleteApiKey(id: $id)
  }
`;

export const GET_API_KEYS_QUERY = /* GraphQL */ `
  query getApiKeys {
    apiKeys: getApiKeysByProject {
      name
      role
      lastUsed
      id
    }
  }
`;

export async function createApiKeyMutation(payload: { role: string; name: string }) {
  return mutateAdmin(CREATE_API_KEY_MUTATION)({
    role: payload.role,
    name: payload.name
  });
}

export async function deleteApiKeyMutation(payload: { id: string }) {
  return mutateAdmin(DELETE_API_KEY_MUTATION)({
    id: payload.id
  });
}

export async function getApiKeysQuery() {
  return queryAdmin(GET_API_KEYS_QUERY)();
}
